<div class="card">
    <div class="card-header">
        <h3 class="card-title"><i class="fa-globe-americas fas"></i> Sites assigned</h3>
    </div>
    <div class="card-body">
            <mat-progress-bar mode="indeterminate" *ngIf="submitted"></mat-progress-bar>
            <div class="app-table pointer">
                <p-table [value]="listFiltered" sortMode="multiple">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [pSortableColumn]="'name'" class="td-name">Site
                                <p-sortIcon [field]="'name'"></p-sortIcon>
                            </th>
                             <th [pSortableColumn]="'read'" class="td-chk">Read
                                <p-sortIcon [field]="'read'"></p-sortIcon>
                            </th>
                           <th [pSortableColumn]="'edit'" class="td-chk">Edit
                                <p-sortIcon [field]="'edit'"></p-sortIcon>
                            </th>
<!--                             <th [pSortableColumn]="'validuntil'" class="td-untildates">Valid until
                                <p-sortIcon [field]="'validuntil'"></p-sortIcon>
                            </th>    -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td class="td-name">{{row.name}}</td>
                            <td class="td-chk  text-right">                                
                                <mat-checkbox class="mat-option" [(ngModel)]="row.read" 
                                ></mat-checkbox>
                            </td>
                            <td class="td-chk text-right">
                                <mat-checkbox class="mat-option" [(ngModel)]="row.edit" 
                                ></mat-checkbox>
                            </td>   
<!--                             <td class="td-untildates">
                                <span class="mr-2">Valid until supervision is validated</span>
                                <mat-checkbox class="mat-option"  [(ngModel)]="row.closeonvalidation" 
                                ></mat-checkbox>
                                {{row.validuntil | date:'dd-MM-yyyy' }}
                            </td> -->
                        </tr>
                    </ng-template>
                </p-table>
            </div>


    </div>
</div>